import FilterMoreModule from "./modules/more";
import FilterFacilityTypeModule from "./modules/facilityTypes";
import FilterObjectModule from "./modules/object";
import FilterPriceModule from "./modules/price";
import FilterRoomsModule from "./modules/rooms";
import FilterMoreApartmentsModule from "./modules/moreApartments";

export default class SearchFilters {
    constructor(config, notification, apartmentsFilter = false) {
        this.notification = notification;
        this.objectModule = apartmentsFilter ? null : new FilterObjectModule(config, notification);
        this.facilityTypeModule = apartmentsFilter ? null : new FilterFacilityTypeModule(config, notification);
        this.roomsModule = new FilterRoomsModule(config, notification);
        this.priceModule = new FilterPriceModule(config, notification);
        this.moreModule = apartmentsFilter ? new FilterMoreApartmentsModule(config, notification) : new FilterMoreModule(config, notification);
    }

    setFilterCallback = (callback) => {
        this.facilityTypeModule?.setCallback(callback);
        this.objectModule?.setCallback(callback);
        this.roomsModule?.setCallback(callback);
        this.priceModule?.setCallback(callback);
        this.moreModule?.setCallback(callback);
    }

    clearPrices = () => {
        this.priceModule.onClearFilter();
    }

    getData = () => {
        const result = {
            rooms: this.roomsModule.getData(),
            price: this.priceModule.getData(),
            more: this.moreModule.getData(),
        };

        if (this.facilityTypeModule !== null) {
            result.facilityTypes = this.facilityTypeModule.getData();
        }

        if (this.objectModule !== null) {
            result.objects = this.objectModule.getData();
        }

        return result;
    };

    getQueryParams = () => {
        let data = this.getData();
        let facilityTypeIds = [];
        let facilityTypes = 0;
        if (this.facilityTypeModule !== null) {
            facilityTypes = data["facilityTypes"];
            data["facilityTypes"].forEach((element, index, array) => {
                facilityTypeIds.push(element.id.toString());
                facilityTypes |= 2 ** element.id;
            });
        }
        facilityTypes = facilityTypes.toString();
        let facilityIds = [];
        let featureQuery = "aFeatures";
        if (this.objectModule !== null) {
            featureQuery = "fFeatures";
            data["objects"].forEach((element, index, array) => {
                facilityIds.push(element.id.toString());
            });
        }
        let facilityQuery = facilityIds.join(",");
        if (facilityQuery !== "") {
            facilityQuery = "facilities=" + facilityQuery;
        }

        let roomIds = [];
        data["rooms"].forEach((element, index, array) => {
            roomIds.push(element.id.toString());
        });
        let roomsQuery = roomIds.join(",");
        if (roomsQuery !== "") {
            roomsQuery = "rooms=" + roomsQuery;
        }

        let moreIds = [];
        data["more"]["features"]["checkboxes"].forEach((element, index, array) => {
            moreIds.push(featureQuery + "=" + element.id.toString() + ";true");
        });
        data["more"]["features"]["inputs"].forEach((element, index, array) => {
            moreIds.push(
                featureQuery + "=" + element.id.toString() + ";" + element.value.toString()
            );
        });

        let queryParams = [];

        let minPrice = data["price"]["min"];
        let maxPrice = data["price"]["max"];
        let priceSet = data["price"]["changed"];
        if (priceSet) {
            queryParams.push("minPricePerNight=" + minPrice);
            queryParams.push("maxPricePerNight=" + maxPrice);
        }

        if (roomsQuery != "") {
            queryParams.push(roomsQuery);
        }
        if (facilityQuery != "") {
            queryParams.push(facilityQuery);
        }
        if (moreIds.length > 0) {
            queryParams = queryParams.concat(moreIds);
        }
        let queryParams_s = queryParams.join("&");
        if (queryParams_s !== "") {
            queryParams_s = queryParams_s;
        }
        let ret = {};
        ret["queryParams"] = queryParams_s;
        ret["facilities"] = facilityIds;
        ret["facilityTypes"] = facilityTypes;
        return ret;
    };
}
